import Container from 'components/molecules/Container/Container';
import FinishedAssessmentContent from './FinishedAssessmentContent';
import NextActionContent from './NextActionContent';
import { StageActionAvailabilityStatus } from 'enums/stageAction';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Loader } from '@spotted-zebra-uk/ui-components';
import { getCompanyLogoUrl } from 'views/CandidatePortal/CandidatePortal.helpers';
import { parseRoleActionCards } from '../RoleStageActions.helpers';
import {
  isStageActionable,
  useRoleStageActionsFlow,
} from './useRoleStageActionsFlow';

/**
 * Post-action thank-you for the roles flow. Still-open stage → "next action"
 * panel exiting onto the actions page (which itself bounces home once the
 * stage closes); everything done → congratulations panel (with the legacy
 * CD-form modal check) exiting onto the role's home screen (portal when
 * enabled, stage list otherwise).
 */
const RoleStageThankYou: FC = () => {
  const { t } = useTranslation();
  const {
    roleId,
    stageId,
    role,
    stage,
    loading,
    exiting,
    actionsUrl,
    roleHomeUrl,
  } = useRoleStageActionsFlow({ exitWhenNotActionable: false });

  if (loading) {
    return (
      <Container className="page-loader-wrapper">
        <Loader variant="bubbles" />
      </Container>
    );
  }

  if (exiting || !role || !stage) {
    return null;
  }

  const actionCards = parseRoleActionCards(stage.actions, t, roleId, stageId);
  const numberOfNotCompletedActions = actionCards.filter(
    actionCard =>
      actionCard.availability !== StageActionAvailabilityStatus.Completed
  ).length;
  const allActionsCompleted = numberOfNotCompletedActions === 0;
  const companyLogoUrl = getCompanyLogoUrl(role.company);

  if (!isStageActionable(stage) || allActionsCompleted) {
    return (
      <FinishedAssessmentContent
        companyName={role.company.name}
        companyLogoUrl={companyLogoUrl}
        stageCandidateId={stage.stageCandidateId}
        exitUrl={roleHomeUrl}
      />
    );
  }

  return (
    <NextActionContent
      numberOfNotCompletedActions={numberOfNotCompletedActions}
      exitUrl={actionsUrl}
      companyName={role.company.name}
      companyLogoUrl={companyLogoUrl}
    />
  );
};

export default RoleStageThankYou;
